import { createAction, createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";

const initialState = {
  value: 0,
  traggliedName: "TITAN 30/11", // ref for tragglied to see if it changed, same default as title in selectedTragglied
};

const traggliedChange = createAction("tragglied/setSelectedTragglied");

const bohrkronendurchmesserSlice = createSlice({
  name: "bohrkronendurchmesser",
  initialState,
  reducers: {
    setBohrkronendurchmesserState(state, action) {
      state.value = action.payload.value;
      state.traggliedName = action.payload.traggliedName;
    },
    setBohrkronendurchmesser(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // called when setSelectedTragglied is called
      .addCase(traggliedChange, (state, action) => {
        // reset if different tragglied
        if (action.payload !== state.traggliedName) {
          state.value = 0;
        }
        // update ref
        state.traggliedName = action.payload;
      })
      .addCase(reset, (state, action) => {
        return initialState;
      });
  },
});

export const { setBohrkronendurchmesserState, setBohrkronendurchmesser } =
  bohrkronendurchmesserSlice.actions;

export default bohrkronendurchmesserSlice.reducer;

export const selectBohrkronendurchmesser = (state) => state.bohrkronendurchmesser.value;

export const selectPreviousBohrkronendurchmesser = (state) =>
  state.bohrkronendurchmesser.previousValue;
